/* eslint camelcase: 0 */
/* eslint no-underscore-dangle: 0 */
/* eslint dot-notation: 0 */
/* eslint no-param-reassign: 0 */

// Mismos tipos de bloque que la categoría de Arduino (incluidos los _custom) porque el
// builder de flyout es compartido. Los tipos de argumento son de Arduino (String, int,
// long, float, char) y no compilan en TypeScript, así que se mapean.

const TS_TYPES = {
  String: 'string',
  char: 'string',
  int: 'number',
  long: 'number',
  float: 'number',
  boolean: 'boolean',
};

const argumentList = (block) => (block.argumentVarModels_ || []).map((model) => {
  const name = model.getName ? model.getName() : model.name;
  const type = model.getType ? model.getType() : model.type;

  return `${name}: ${TS_TYPES[type] || 'number'}`;
});

export const procedures_defreturn = (block, generator) => {
  const funcName = generator.getProcedureName(block.getFieldValue('NAME'));
  const branch = block.getInput('STACK') ? generator.statementToCode(block, 'STACK') : '';
  const returnValue = block.getInput('RETURN')
    ? (generator.valueToCode(block, 'RETURN', generator.ORDER_NONE) || '')
    : '';

  const body = returnValue
    ? `${branch}${generator.INDENT}return ${returnValue}\n`
    : branch;

  // Va a definitions_ con el % adelante para no colisionar con las funciones
  // auxiliares que inyectan otros bloques, igual que la capa Arduino.
  generator.definitions_[`%${funcName}`] = `\nfunction ${funcName}(${argumentList(block).join(', ')}) {\n${body}}\n`;

  return null;
};

export const procedures_defnoreturn = procedures_defreturn;

export const procedures_callreturn_custom = (block, generator) => {
  const funcName = generator.getProcedureName(block.getFieldValue('NAME'));
  const args = (block.argumentVarModels_ || [])
    .map((_, i) => generator.valueToCode(block, `ARG${i}`, generator.ORDER_NONE) || 'null');

  return [`${funcName}(${args.join(', ')})`, generator.ORDER_FUNCTION_CALL];
};

export const procedures_callnoreturn_custom = (block, generator) => {
  const funcName = generator.getProcedureName(block.getFieldValue('NAME'));
  const args = (block.argumentVarModels_ || [])
    .map((_, i) => generator.valueToCode(block, `ARG${i}`, generator.ORDER_NONE) || 'null');

  return `${funcName}(${args.join(', ')})\n`;
};

export const procedures_ifreturn = (block, generator) => {
  const condition = generator.valueToCode(block, 'CONDITION', generator.ORDER_NONE) || 'false';
  const value = block.hasReturnValue_
    ? (generator.valueToCode(block, 'VALUE', generator.ORDER_NONE) || 'null')
    : '';

  return `if (${condition}) {\n${generator.INDENT}return ${value}\n}\n`;
};
